var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenewCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1841",
    "data-name": "Rectangle 1841",
    width: 10,
    height: 10,
    transform: "translate(-0.272)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3345",
    "data-name": "Group 3345",
    transform: "translate(0.299 0.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2412",
    "data-name": "Group 2412",
    transform: "translate(-0.027 -0.027)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49158",
    "data-name": "Path 49158",
    d: "M9.7,4.851A4.851,4.851,0,1,1,4.851,0,4.851,4.851,0,0,1,9.7,4.851",
    transform: "translate(0.026 0.026)",
    fill: "#fdcb28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49159",
    "data-name": "Path 49159",
    d: "M194.025,161.665h-.467a.248.248,0,0,1-.245-.212l-.106-.706a2.364,2.364,0,0,0-.39-.972,1.709,1.709,0,0,1-.291-1.048,1.739,1.739,0,0,1,1.6-1.629q.059,0,.116,0a1.721,1.721,0,0,1,1.425,2.688,2.51,2.51,0,0,0-.4,1.05l-.1.644a.236.236,0,0,1-.219.189h-.042l-.888,0",
    transform: "translate(-189.368 -154.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49160",
    "data-name": "Path 49160",
    d: "M184.441,147.127c-.042,0-.084,0-.127,0a1.883,1.883,0,0,0-1.436,2.93,2.213,2.213,0,0,1,.364.905l.106.706a.411.411,0,0,0,.4.35h.466l.932,0a.4.4,0,0,0,.379-.327l.1-.644a2.367,2.367,0,0,1,.372-.983,1.883,1.883,0,0,0-1.558-2.941m1.291,2.758a2.67,2.67,0,0,0-.425,1.117l-.1.644a.079.079,0,0,1-.059.051h-.058l-.874,0h-.464a.087.087,0,0,1-.086-.075l-.106-.706a2.524,2.524,0,0,0-.416-1.038,1.548,1.548,0,0,1-.263-.95,1.575,1.575,0,0,1,1.452-1.476c.035,0,.071,0,.106,0a1.559,1.559,0,0,1,1.291,2.434",
    transform: "translate(-179.565 -144.71)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49161",
    "data-name": "Path 49161",
    d: "M246.135,467.633h-1.494a.13.13,0,1,1,0-.259h1.494a.13.13,0,1,1,0,.259",
    transform: "translate(-240.512 -459.752)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49162",
    "data-name": "Path 49162",
    d: "M269.208,501.138h-.7a.13.13,0,0,1,0-.259h.7a.13.13,0,0,1,0,.259",
    transform: "translate(-263.989 -492.712)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49163",
    "data-name": "Path 49163",
    d: "M260.034,277.054h0a.078.078,0,0,1-.075-.081,6.4,6.4,0,0,0-.307-2.421.078.078,0,1,1,.131-.083,6.349,6.349,0,0,1,.331,2.51.078.078,0,0,1-.078.075",
    transform: "translate(-255.391 -269.946)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49164",
    "data-name": "Path 49164",
    d: "M239.441,270.47a.578.578,0,0,1-.188-.022.31.31,0,0,1-.2-.162.262.262,0,0,1,.107-.337.266.266,0,0,1,.345.073.078.078,0,0,1-.128.089.113.113,0,0,0-.142-.026.106.106,0,0,0-.043.134.157.157,0,0,0,.108.082.478.478,0,0,0,.147.014h.617a.078.078,0,0,1,0,.156h-.626Z",
    transform: "translate(-235.12 -265.502)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49165",
    "data-name": "Path 49165",
    d: "M307.759,277.059a.078.078,0,0,1-.078-.075,6.35,6.35,0,0,1,.331-2.51.078.078,0,1,1,.131.083,6.4,6.4,0,0,0-.307,2.421.078.078,0,0,1-.075.081h0",
    transform: "translate(-302.648 -269.951)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49166",
    "data-name": "Path 49166",
    d: "M290.029,270.47H289.4a.078.078,0,0,1,0-.156h.617a.49.49,0,0,0,.147-.014.157.157,0,0,0,.108-.082.106.106,0,0,0-.043-.134.113.113,0,0,0-.142.026.078.078,0,0,1-.128-.089.266.266,0,0,1,.345-.073.262.262,0,0,1,.107.337.31.31,0,0,1-.2.162.579.579,0,0,1-.188.022",
    transform: "translate(-284.597 -265.501)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49167",
    "data-name": "Path 49167",
    d: "M291.625,69.913a.113.113,0,0,1-.113-.113v-.61a.113.113,0,1,1,.227,0v.61a.113.113,0,0,1-.113.113",
    transform: "translate(-286.748 -67.927)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49168",
    "data-name": "Path 49168",
    d: "M160.518,124.176a.113.113,0,0,1-.08-.033l-.431-.431a.113.113,0,1,1,.16-.16l.431.431a.113.113,0,0,1-.08.194",
    transform: "translate(-157.347 -121.485)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49169",
    "data-name": "Path 49169",
    d: "M396.6,124.25a.113.113,0,0,1-.08-.194l.431-.431a.113.113,0,1,1,.16.16l-.431.431a.113.113,0,0,1-.08.033",
    transform: "translate(-390.017 -121.557)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49170",
    "data-name": "Path 49170",
    d: "M440.638,255.3h-.61a.113.113,0,0,1,0-.227h.61a.113.113,0,1,1,0,.227",
    transform: "translate(-432.739 -250.906)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49171",
    "data-name": "Path 49171",
    d: "M106.25,256.027h-.61a.113.113,0,1,1,0-.227h.61a.113.113,0,1,1,0,.227",
    transform: "translate(-103.786 -251.616)",
    fill: "#3d3d3d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewCoin);
export default __webpack_public_path__ + "static/media/Renew-coin.4d19d511c3fb9e83f78d1b97f5512f0f.svg";
export { ForwardRef as ReactComponent };